import { SxProps, Theme } from '@mui/material';

/** The width of the send PDF report dialog (views/reports/wizard/dialog.tsx). */
export const companyDialogSx = {
  '& .MuiDialog-paper': {
    m: 2,
    width: '100%',
    maxWidth: { xs: 720, sm: 920, md: 1040 },
  },
} satisfies SxProps<Theme>;
